"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IZiPoolCode = void 0;
const chain_1 = require("@zenlink-interface/chain");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const viem_1 = require("viem");
const HEXer_1 = require("../../HEXer");
const PoolCode_1 = require("./PoolCode");
class IZiPoolCode extends PoolCode_1.PoolCode {
    constructor(pool, providerName) {
        super(pool, providerName);
        this.executor = {
            [chain_1.ParachainId.SCROLL_ALPHA]: '0x9A25abd7F3044808fc2FB8aBc96f44437a96D212',
            [chain_1.ParachainId.SCROLL]: '0x7B1128E610ae1d461B7B8227f9FBBB39e336c515',
        };
    }
    getProtocolExecutor() {
        const chainId = this.pool.token0.chainId;
        (0, tiny_invariant_1.default)(chainId !== undefined, 'IZiPoolCode: Unseted chainId');
        return this.executor[Number(chainId)];
    }
    getProtocolExecutorStartPoint() {
        return this.getProtocolExecutor();
    }
    getSwapCodeForRouteProcessor(_leg, _route, _to) {
        return 'unsupported';
    }
    getSwapCodeForRouteProcessor2(_leg, _route, _to) {
        return 'unsupported';
    }
    getSwapCodeForAggregationRouter(leg, _route, to) {
        const code = new HEXer_1.HEXer()
            .address(this.getProtocolExecutor())
            .bytes((0, viem_1.encodeAbiParameters)((0, viem_1.parseAbiParameters)('address, bool, address'), [
            this.pool.address,
            leg.tokenFrom.address === this.pool.token0.address,
            to,
        ]))
            .toString();
        return code;
    }
}
exports.IZiPoolCode = IZiPoolCode;
